import FNumber from '../FNumber';
import component from './component.vue';

export default class FPrice extends FNumber {
  __component = component;

  constructor(props) {
    super(props);
    this.scale = (props.scale || props.scale === 0) ? props.scale : 2;
    this.currency = props.currency || '';
  }
}
